import { useClassAppender } from './hooks/useClassAppender';

export const FeatureToggleClassAppender = (): null => {
  useClassAppender();
  return null;
};